import Parser from '@u4i/utils/Parser';

export interface IChapter {
  challengesCompleted: boolean;
  challengesSubmitted: boolean;
  contents: Array<{
    id: string;
    text: string;
  }>;
  description: string;
  duration: number;
  hasChallenges: boolean;
  hasMandatoryChallenges: boolean;
  id: string;
  language: string;
  preview: {
    url: string;
  };
  providers: Array<{
    id: string;
    name: string;
    url: string;
  }>;
  slug: string;
  summaries: Array<{
    id: string;
    text: string;
  }>;
  summaryPDF: string;
  title: string;
}

export const ChapterParser = new Parser<IChapter>((chapter) => ({
  challengesCompleted: chapter.challenges_completed,
  challengesSubmitted: chapter.challenges_submitted,
  contents: chapter.contents.map(content => ({
    id: btoa(unescape(encodeURIComponent(content))),
    text: content,
  })),
  description: chapter.description,
  duration: chapter.duration,
  hasChallenges: chapter.has_challenges,
  hasMandatoryChallenges: chapter.has_mandatory_challenges,
  id: chapter.id,
  language: chapter.language,
  preview: {
    url: chapter.preview.url,
  },
  providers: chapter.providers.map(provider => ({
    id: provider.id,
    name: provider.name,
    url: provider.url,
  })),
  slug: chapter.slug,
  showProviders: chapter.show_providers,
  summaries: chapter.summaries.map(summary => ({
    id: btoa(unescape(encodeURIComponent(summary))),
    text: summary,
  })),
  summaryPDF: chapter.pdf_summary_url,
  title: chapter.title,
}));
